module.exports = __webpack_public_path__ + "media/images/resources/documents-icon-418b0fe31c8c16f7e188a09d7e563f77.svg";